import { CoverImage } from '../otp/viewModel/editOtpBundle.vm';

/**
 * Handoff payload used to prefill the "Create new offer" form when a creator
 * clicks "Add to Offer" from a program. Stored in sessionStorage so it survives
 * the navigation from the program page to the offers page.
 */
type OfferPrefillFromProgram = {
  programId: number;
  name: string;
  description?: string;
  coverImage: CoverImage | null;
};

const STORAGE_KEY = 'offer-prefill-from-program';

export const setOfferPrefillFromProgram = (
  payload: OfferPrefillFromProgram,
): void => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
};

export const consumeOfferPrefillFromProgram =
  (): OfferPrefillFromProgram | null => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      sessionStorage.removeItem(STORAGE_KEY);

      return JSON.parse(raw) as OfferPrefillFromProgram;
    } catch {
      // sessionStorage may be unavailable (privacy modes, blocked storage) or
      // the stored payload may be malformed — treat both as "no prefill".
      return null;
    }
  };
